// Sessions API client (D-52, 19A §6.5): the caller's OWN GoTrue sessions, via the
// licence backend's /users/me/sessions routes (backend/src/routes/sessions.routes.ts).
// Self-service by construction: there is no user id anywhere in these calls — the
// server takes it from the bearer token.
import { apiRequest } from '@/lib/supabase';

export interface SessionPolicy {
  /** Seconds without a token refresh before GoTrue ends a session; 0 = no limit. */
  inactivity_timeout_seconds: number;
  /** Seconds of absolute session age; 0 = no limit. */
  timebox_seconds: number;
}

export interface SessionRow {
  id: string;
  created_at: string | null;
  /** auth.sessions.refreshed_at: when the session last renewed its sign-in. */
  last_active_at: string | null;
  ip: string | null;
  label: string;
  is_current: boolean;
}

export interface SessionList {
  sessions: SessionRow[];
  policy: SessionPolicy | null;
}

/** What the idle detector follows. Open to an aal1 session: read once per sign-in. */
export function fetchSessionPolicy(): Promise<{ policy: SessionPolicy }> {
  return apiRequest<{ policy: SessionPolicy }>('/users/me/sessions/policy');
}

export function fetchSessions(): Promise<SessionList> {
  return apiRequest<SessionList>('/users/me/sessions');
}

/** End one of my OTHER sessions. A 404 means it had already ended. */
export function revokeSession(id: string): Promise<{ revoked: true }> {
  return apiRequest<{ revoked: true }>(`/users/me/sessions/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

/** "Sign out all other sessions". */
export function revokeOtherSessions(): Promise<{ revoked_count: number }> {
  return apiRequest<{ revoked_count: number }>('/users/me/sessions/revoke-others', { method: 'POST', body: '{}' });
}
